//
//
//
//

export default {
  name: "302",
  methods: {
    getParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = location.search.substr(1).match(reg);
      if (r != null) return unescape(decodeURI(r[2]));
      return null;
    }
  },
  created() {
    if(this.getParam('code')&&this.getParam('state')=='gaishi_get_code'){
      let url=location.protocol+'//'+location.host+'/#/?code='+this.getParam('code')+'&state='+this.getParam('state');
      console.log(url);
      location.assign(url);
    }else{
      this.$router.replace({name:'tutorial'});
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/chongdingxiang/chongdingxiang.vue